import { render, staticRenderFns } from "./tagsLayout.vue?vue&type=template&id=e2882734"
import script from "./tagsLayout.vue?vue&type=script&lang=ts"
export * from "./tagsLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports